import * as React from "react";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import { FileDownload } from "../../misc/FileDownload";
import { useParams } from "react-router-dom";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";


export const CoughUploadReport = () => {
    const { reportId } = useParams<{ reportId: string }>();
    const [errorAlert, setErrorAlert] = React.useState<string | undefined>();

    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getReport = async () => {
            try {
                setErrorAlert(undefined);
                const fileResult = await legacyClient.getCoughUploadReport(reportId);

                FileDownload(fileResult, "CoughUploadReport.html");
            } catch (ex) {
                setErrorAlert(ex.message);
            }
        }

        getReport();
    }, [reportId]);

    return (
        <div className="row">
            <div className="col-md-12">
                {errorAlert ? <Alert category={AlertCategoryEnum.Danger} show={errorAlert !== undefined}>
                    {errorAlert}
                </Alert> : <Alert category={AlertCategoryEnum.Info} show={true}>Your report will be downloading in the background</Alert>}
            </div>
        </div>
    );
}
